export default __webpack_public_path__ + "static/media/tractor.2e4087ef.png";